var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Phone icon"),React.createElement("path",{"d":"M83.7 127.6c15.6 15.5 33.6 30.3 40.7 23.1 10.1-10.2 16.4-19.1 38.9-1.2 22.5 18 5.3 30-4.5 39.9-11.3 11.4-53.8.8-95.9-41-42.1-41.6-53.1-84-41.7-95.4C31 43.1 43 25.8 61.1 48.2c18.1 22.4 9.3 28.7-.9 38.9-7 7.1 7.9 25 23.5 40.5zm22.6-73.8s-4.7-.7-8 2.6c-3.4 3.4-3.5 9.2 0 12.8 2.1 2.1 5.1 2.6 5.1 2.6 5.8 1.1 14.5 2.9 23.9 12.2 9.3 9.3 11.1 18 12.2 23.9 0 0 .4 3 2.6 5.1 3.6 3.6 9.4 3.4 12.8 0 3.3-3.3 2.6-8 2.6-8-1.8-11.8-7.5-24-17.3-33.8-9.9-9.9-22.2-15.6-33.9-17.4zm44.1 7c17.1 17.1 24.3 36.4 22 52.1 0 0-.8 5 2.4 8.2 3.7 3.7 9.4 3.4 12.9 0 2.2-2.2 2.7-5.8 2.7-5.8 2-13.6-.5-40.8-27.1-67.4-26.6-26.6-53.8-29-67.4-27.1 0 0-3.6.5-5.8 2.7-3.4 3.4-3.6 9.2 0 12.9 3.2 3.2 8.2 2.4 8.2 2.4 15.7-2.3 35 5 52.1 22z","key":1})]);
}

Phone.defaultProps = {"viewBox":"0 0 210.9 210.9"};

module.exports = Phone;

Phone.default = Phone;
